'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var dayView_styles = require('./day-view.styles-e8bc0482.js');

var allowedActiveStates = new Set(['available', 'active', 'current', 'adjacentMonth']);

var DayView = function (_a) {
    var data = _a.data, index = _a.index, handleClick = _a.onClick, size = _a.size;
    var testId = "day-cell-" + data.month + "-" + data.date + "-" + data.year;
    var handlePress = React.useCallback(function (_, event) {
        if (allowedActiveStates.has(data.status)) {
            handleClick(index, data, event);
        }
    }, [index, handleClick, data]);
    return (React__default.createElement(dayView_styles.DayCell, { number: data.date, variant: data.status, onPress: handlePress, className: "day-cell day-cell-" + data.status + " day-" + data.date + " month-" + data.month + " year-" + data.year, size: size, "data-cy": testId, "data-testid": testId }));
};

exports.DayView = DayView;
